import {
    anims_bigwin_pulse_win,
    anims_blink_cover_start, anims_blink_cover_stop,
    anims_bw_bubbles,
    anims_bw_bubbles_stop,
    anims_change_bigwin_type, anims_hide_bigwin_counter,
    anims_open_bigwin_counter,
    anims_play_winline_anim,
    anims_play_winline_particles,
    anims_pulse_bigwin_counter,
    anims_pulse_symbols, anims_pulse_symbols_stop,
    anims_pulse_wild_reel_win,
    anims_set_origin_tmp_symbols,
    anims_set_tmp_symbols, anims_show_origin_symbols,
    anims_stop_bigwin_anim, fadeout_black_screen,
    hide_all_win_particles,
    loop_bigwin_particles, stop_bigwin_particles
} from "./jokerboom_anims";
import {ctrl_counter, get_real_mega_win, in_bonus, preload_win_particles} from "./jokerboom_ctrl";
import {anim_winlines, hide_all_winlines} from "./jokerboom_winlines";
import {madnes_set_img_center, madnes_set_pos, madnes_set_visible} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_audio_fade_in,
    madnes_audio_fade_out, madnes_audio_fade_to,
    madnes_audio_loop,
    madnes_audio_pause,
    madnes_audio_play, madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    bet,
    madnes_get_atomic_bet,
    madnes_money_to_coin
} from "../framework/src/engine/madnes/madnes";
import {
    states,
    big_win,
    he,
    mega_win,
    super_win,
    wi,
    set_inbigwin
} from "../framework/src/engine/madnes/madnes_variables";
import {
    coins_anim_bigwin_play,
    coins_anim_bigwin_stop,
    coins_explode_bigwin,
    coins_hide,
    coins_show
} from "./jokerboom_coins";
import {hide_win_text, write_bigwin_text, write_win_text} from "./jokerboom_reels";
import {boom_spins_count, result_add_big_win, result_control_next_part} from "./jokerboom_core_res_ctrl";
import {BigWinCounter} from "./BigWinCounter";
import {STATES} from "../framework/src/states/states";

export function anims_winlines_bigwin_play(symbols, lineWins, totalWin)
{

    // madnes_hide_btns();

    var waitForAnim = [];
    var p;

    var bigWinManager = new BigWinManger();

    anims_set_tmp_symbols(symbols);

    in_bonus && anims_pulse_wild_reel_win();

    anims_blink_cover_start();

    p = anims_play_winline_anim(symbols).then(function() {

        anims_set_origin_tmp_symbols(symbols);

        //console.log("end of winline anim");

        return new Promise(function(res) {
            setTimeout(function() {
                //console.log("end of pause");
                res();
            }, 400);
        });

    });
    waitForAnim.push(p);

    p = anim_winlines(lineWins);
    waitForAnim.push(p);

    preload_win_particles();
    p = anims_play_winline_particles(symbols, 30).then(function() {
        hide_all_win_particles();
        //console.log("end of particle anim");
    });
    waitForAnim.push(p);

    madnes_set_pos("preload_bigwins", 0, 0);
    madnes_set_visible("preload_bigwins", true);

    if(in_bonus) {
        madnes_audio_fade_out("audio_bonus_bg", 500, false, function() {
            madnes_audio_pause("audio_bonus_bg");
        });
    }

    setTimeout(function() {
        madnes_audio_loop('remittance_A');
    }, 250);

    if(totalWin < get_real_mega_win(madnes_get_atomic_bet())) {

        madnes_audio_play("audio_big_win");

        ctrl_counter(8800, 0, madnes_money_to_coin(totalWin), function(val) {

            bigwin_onupdate(val, bigWinManager);

        }).then(function() {
            bigwin_end(bigWinManager, symbols);
        });
    } else {

        bigWinManager.stateMegaWin = true;

        madnes_audio_play("audio_mega_win");

        var bigWinCounter = new BigWinCounter(madnes_money_to_coin(totalWin), bet, [big_win, mega_win, super_win]);
        bigWinCounter.onUpdate(function(val) {

            bigwin_onupdate(val, bigWinManager);

        });

        bigWinCounter.onMegaWin(function() {
            coins_explode_bigwin("megawin");
            anims_stop_bigwin_anim();
            anims_change_bigwin_type("bigwins_mwin").then(function () {
                anims_pulse_bigwin_counter();
            });
        });

        bigWinCounter.onSuperWin(function() {
            coins_explode_bigwin("supermegawin");
            anims_stop_bigwin_anim();
            anims_change_bigwin_type("bigwins_swin").then(anims_pulse_bigwin_counter);
        });

        bigWinCounter.run().then(function() {
            bigwin_end(bigWinManager, symbols);
        });
    }

    setTimeout(function() {
        states.setState(STATES.BONUS_WIN);

        bigwin_start(bigWinManager);
    }, 1300);

}

function bigwin_onupdate(val, bigWinManager) {
    if(!bigWinManager.stateBigWin) {
        write_win_text(val | 0);
    } else {
        write_bigwin_text(val | 0);
    }
}

function bigwin_start(bigWinManager)
{
    anims_pulse_symbols();

    //bigWinManager.stateBigWin = true;
    //hide_win_text();

    //lag hack (preload texture before anim)
    madnes_set_img_center("bw_particles_" + 0, 0, 0);
    madnes_set_pos("bw_particles_" + 0, wi - 10, he - 10);
    madnes_set_visible("bw_particles_" + 0, true);
    //madnes_sprite_set_frame_name("bw_particles_" + 0, "particles_00000"); //particles_bigWin_00000

    madnes_set_visible("preload_coin", true);

    coins_hide();
    coins_explode_bigwin("bigwin");
    coins_anim_bigwin_play();

    //madnes_audio_play("audio_big_win_explosion");

    setTimeout(function() {
        coins_show();
    }, 400);

    setTimeout(function() {
        bigWinManager.stateBigWin = true;
        hide_win_text();

    }, 400);

    anims_open_bigwin_counter(300).then(function() {

        loop_bigwin_particles();

        //bigWinManager.stateBigWin = true;

        anims_pulse_bigwin_counter();
        setTimeout(anims_bw_bubbles, 100);
    });

}

function bigwin_end(bigWinManager, symbols) {

    result_add_big_win();

    madnes_audio_stop('remittance_A');

    madnes_set_visible("preload_coin", false);
    madnes_set_pos("preload_bigwins", -9999, -9999);
    madnes_set_visible("preload_bigwins", false);

    setTimeout(anims_bw_bubbles_stop, 400);
    coins_anim_bigwin_stop();

    if(bigWinManager.stateMegaWin) {
        madnes_audio_fade_to("audio_mega_win", 0, 600, function() {
            madnes_audio_stop("audio_mega_win");
        });

        madnes_audio_play("audio_big_win_end");
    }

    new Promise(function(res) {

        anims_stop_bigwin_anim();

        anims_bigwin_pulse_win().then(function() {

            setTimeout(stop_bigwin_particles, 200);

            setTimeout(function() {
                anims_hide_bigwin_counter();
                coins_hide();
                res();
            }, 500);
        });

    }).then(function() {

        anims_blink_cover_stop();

        hide_all_winlines();
        fadeout_black_screen().then(function() {

            if(in_bonus && boom_spins_count > 0) {
                madnes_audio_loop("audio_bonus_bg");
                madnes_audio_fade_in("audio_bonus_bg", 1000);
            }

            anims_show_origin_symbols(symbols);

            anims_pulse_symbols_stop();
            set_inbigwin(false);

            setTimeout(result_control_next_part, 500);

        });

    });
}

function open_bigwin_counter(winCounter, totalWin)
{
    winCounter.stop(false);

    if(totalWin > get_real_mega_win(bet))
    {
        //supermegawin
    }
    else
    {
        madnes_audio_play("audio_big_win");

        ctrl_counter(8500, winCounter.winVal, totalWin, function(val) {
            write_win_text(val);
        });
    }

    hide_all_winlines();
    //anims_show_origin_symbols(symbols);
    result_control_next_part();

}

/**
 * @constructor
 * @returns {BigWinManger}
 */
function BigWinManger() {
    this.stateBigWin = false;
    this.stateMegaWin = false;
    //this.songName;
    //this.songEndSound = false;
}